module.exports = __webpack_public_path__ + "media/images/icon_sort_btn_favorite_on-6546ff87d3fef934cc6610c1e48ac42d.png";